module.exports = __webpack_public_path__ + "img/demo-tool.02b537f4.gif";